var _path, _path2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 176,
    viewBox: "0 0 176 176",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 88.0087V132.004C66 156.306 85.6962 176 110 176V44C97.8481 44 86.8449 48.9334 78.8828 56.8815C70.9339 64.8558 66 75.845 66 88.0087Z",
    fill: "url(#paint0_linear_538_65)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6623 0.0130415H66.0026C90.3049 0.0130415 110 19.7034 110 44H66.0026H36.6623C16.406 44 0 27.5848 0 7.33333V0H36.6623V0.0130415Z",
    fill: "url(#paint1_linear_538_65)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M139.325 0.0130434H109.997C85.6951 0.0130434 66 19.7064 66 44.0065V88C66 75.8499 70.9335 64.8483 78.8821 56.8874C86.8436 48.9266 97.8462 44.0065 109.997 44.0065H139.325C159.581 44.0065 176 27.5889 176 7.33441V0H139.325V0.0130434Z",
    fill: "#3356A6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_538_65",
    x1: 88.0023,
    y1: 44.0013,
    x2: 88.0023,
    y2: 176.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C75BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0784,
    stopColor: "#2086C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1812,
    stopColor: "#2599D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2673,
    stopColor: "#2AA6DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3254,
    stopColor: "#2CAAE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_538_65",
    x1: -0.00104414,
    y1: 22.005,
    x2: 110.004,
    y2: 22.005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3612,
    stopColor: "#2CAAE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1C75BC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTLogo);
export default __webpack_public_path__ + "static/media/t-logo.d3163182eae9db46b37b02123f3ebe0c.svg";
export { ForwardRef as ReactComponent };